<div class="flex items-center gap-2 pl-4 py-3">

  <button class="btn btn-ghost btn-sm btn-circle" (click)="goBack()">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
    </svg>
  </button>

  <ng-content />

  <article class="lg:flex rounded h-10">
    <app-input-search [placeholder]="literalService.get(restrictionsTarget() === RestrictionsTarget.AREAS ? 'services.routes.restrictions.searchAreaPlaceholder' : 'services.routes.design.fstop.searchPlaceholder', true)"
      [searchValue]="searchValue"
      (submitEventEmitter)="search($event)"></app-input-search>
  </article>

  <article class="relative lg:flex rounded h-10">
    <button id="buttonRestrictionsRowsDisplayOpen"
      class="rowsDisplayButton text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
      [ngClass]="{ 'opened': rowsDisplayOpened, 'filtersApplied': pageSize() !== defaultPageSize }" (click)="rowsDisplayOpened = !rowsDisplayOpened">
      <img [src]="images.visibility" alt="rowsDisplay" class="w-6 h-6 mr-2" [ngClass]="{ 'filterOpened': rowsDisplayOpened || pageSize() !== defaultPageSize }" />
      <span class="font-semibold text-base">{{ `${literalService.get('bookings.show', true)}: ${pageSize()}` }}</span>
    </button>
    <article class="flex absolute mt-15 w-auto z-30 bg-white" [ngClass]="{ 'hidden': !rowsDisplayOpened }">
      <app-rows-display [componentOpen]="'buttonRestrictionsRowsDisplayOpen'" [value]="pageSize()" (close)="rowsDisplayOpened = false" (onChange)="changePageSize($event)"></app-rows-display>
    </article>
  </article>

  @if (restrictionsTarget() === RestrictionsTarget.STOPS) {
    <app-custom-toggle
      class="mx-2 shrink-0"
      [id]="'restrictions-type-toggle'"
      [selectedValue]="restrictionsType()"
      [options]="restrictionsTypeToggleOptions"
      [controlled]="true"
      (action)="changeRestrictionType($event)"
    />
  }

  <div class="relative select-with-icon mr-4 mx-2">
    <img [src]="images.origin" alt="origin" class="absolute left-2 top-1/2 -translate-y-1/2 h-4 w-4 z-10 pointer-events-none" />
    <select2
      class="block w-60"
      [data]="stopOptions()"
      [value]="selectedOriginId"
      [placeholder]="literalService.get('services.routes.restrictions.selectOrigin', true)"
      [templates]="{option: option}"
      (update)="onOriginSelect($event)"
    >
      <ng-template #option let-label="label">
        <app-select2-option [label]="label" />
      </ng-template>
    </select2>
  </div>

  <div class="relative select-with-icon w-60 mr-4">
    <img [src]="images.destination" alt="destination" class="absolute left-2 top-1/2 -translate-y-1/2 h-4 w-4 z-10 pointer-events-none" />
    <app-multi-select-form
      class="block w-60"
      [title]="'restrictions-destinations'"
      [elements]="destinationOptions"
      [values]="selectedDestinations"
      [width]="'60'"
      [iconLeft]="true"
      [pinSelectedToTop]="true"
      [orderById]="false"
      [showSelectAll]="true"
      [selectAllChecksItems]="true"
      [dropdownMaxHeight]="'400px'"
      [disabled]="!selectedOriginId"
      [placeholder]="literalService.get('services.routes.restrictions.selectDestination', true)"
    />
  </div>

  <button
    class="btn btn-sm bg-primary-purple text-neutrals-white rounded-full px-5 uppercase disabled:opacity-30 disabled:cursor-not-allowed"
    [disabled]="!selectedOriginId || selectedDestinations.length === 0"
    (click)="addRestriction()"
  >
    {{ literalService.get('add', true) }}
  </button>
<!-- 
  <button class="btn btn-ghost btn-sm btn-circle ml-auto">
    <img [src]="images.services.routes.delete" alt="delete" class="h-5 w-5" />
  </button> -->

  <section class="flex ml-auto gap-4 items-center">
    @if (whiteListDraftMode()) {
      <button type="button" class="btn btn-sm btn-outline rounded-full px-5 uppercase" (click)="onCancelWhiteListDraftClick()">
        {{ literalService.get('cancel', true) }}
      </button>
      <button
        type="button"
        class="btn btn-sm bg-primary-purple text-neutrals-white rounded-full px-5 uppercase disabled:opacity-30 disabled:cursor-not-allowed"
        [disabled]="whiteListDraftSize() === 0"
        (click)="onConfirmWhiteListDraftClick()"
      >
        {{ literalService.get('confirm', true) }}
      </button>
    } @else {
      @if (bulkSelectMode() && selectedCount() > 0) {
        <article class="px-4 py-1 rounded-[44px] cursor-pointer bg-primary-purple-light text-neutrals-white" (click)="onConfirmBulkDeleteClick()">
          {{ literalService.get('services.routes.restrictions.bulkDelete.action', true) }}
        </article>
      }
      <article
        class="w-10 h-10 flex justify-center items-center rounded-full cursor-pointer outlinedButton"
        [ngClass]="{ 'bg-primary-purple-light-2 selected': bulkSelectMode() }"
        (click)="onBulkDeleteClick()"
      >
        <img [src]="images.services.routes.delete" alt="delete" class="h-6 w-6" [ngClass]="{ 'selected': bulkSelectMode() }" />
      </article>
      @if (bulkSelectMode()) {
        <article class="w-10 h-10 flex justify-center items-center rounded-full cursor-pointer outlinedButton" (click)="onCancelBulkClick()">
          <img [src]="images.close" alt="cancelBulk" class="w-6 h-6" />
        </article>
      }
    }
  </section>

</div>
